import { render, staticRenderFns } from "./MitMenuUser.vue?vue&type=template&id=5820e413&scoped=true"
import script from "./MitMenuUser.vue?vue&type=script&lang=js"
export * from "./MitMenuUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5820e413",
  null
  
)

export default component.exports